export default function Footer() {
  return (
    <footer className="border-t border-white/10 py-12" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 flex flex-col sm:flex-row items-center justify-between gap-6">
        <div className="flex items-center gap-3">
          <img src="/assets/logo.jpeg" alt="Projeto Bonsai BJJ" className="w-10 h-10 rounded-full object-cover ring-1 ring-gold/50" />
          <div>
            <p className="font-display font-bold text-sm">PROJETO <span className="text-gold">BONSAI</span> BJJ</p>
            <p className="text-xs text-zinc-500">Prof. Marciano — Sorocaba/SP</p>
          </div>
        </div>
        <p className="font-mono text-xs text-zinc-600 text-center" data-testid="footer-copyright">
          © 2026 Projeto Bonsai BJJ · Cultivando vidas através do Jiu-Jitsu
        </p>
      </div>
    </footer>
  );
}
